export const ACTIVITY_TYPES_CORE = {
	// STEP_START / STEP_END / STEP_ERROR are GONE ON PURPOSE (Lane-C scanner cut): their sole emitter,
	// tools/activity/step-executor.ts, was deleted with the compliance-scanner activity lane, leaving all three with zero
	// emitters and zero symbolic references. Cut WITH the EventCatalogKey arms and the stub-catalog entries in the same
	// change, which is what keeps QUAL-ACTIVITY-EVENT-CATALOG-TRIAD-DRIFT-001 and the compile-time
	// _AssertActivityCoveredByCatalog assertion in lockstep. Do not re-add them without a producer.
	//
	// SIX MORE went the same way 2026-08-13, same atomic three-surface shape: DATA_ACCESS / DATA_WRITE (the scanner
	// `deps.logActivity` arms, dead with the Lane-C activity lane), SESSION_END (the `createBeforeUnloadHandler` emit,
	// dead with the client activity no-op chain), and the AUTH_MODAL_OPENED / OTP_PAGE_VIEWED / OTP_VERIFIED funnel
	// trio (same chain). Each was a `QUAL-ACTIVITY-TYPE-ZERO-READER-001` true positive -- zero emitters and zero
	// symbolic references -- and each was verified absent from `migrations/**` in both the bare and the SQL-doubled
	// (`''value''`) spelling first, so no seeded `metrics.measurement_formula` reads them. Same re-add bar: ship the
	// producer in the same change.
	ISSUE: 'issue',
	ERROR: 'error',
	BALANCE_ADJUSTED: 'balance_adjusted',
	AUTHENTICATION_ATTEMPT: 'authentication_attempt',
	USER_LOGIN: 'user_login',
	USER_LOGOUT: 'user_logout',
	WEBSOCKET_DISCONNECTED: 'websocket_disconnected',
	SESSION_DB_OPERATION: 'session_db_operation',
	SESSION_START: 'session_start',
	SEARCH: 'search',
	EXACT_SEARCH: 'exact_search',
	RAW_ACTIVITY: 'raw_activity',
	COMPLIANCE_SCAN: 'compliance_scan',
	// User lifecycle
	USER_REGISTRATION: 'user_registration',
	PROFILE_UPDATE: 'profile_update',
	// Session & system
	WARNING: 'warning',
	ERROR_ENCOUNTERED: 'error_encountered',
	FEATURE_USED: 'feature_used',
	REFUND_INITIATED: 'refund_initiated',
	REFUND_COMPLETED: 'refund_completed',
	// Admin refund-priority audit rows written by flows/ledger-refund-set-priority.ts. SPELLING IS LOAD-BEARING -- see the Title-Case note at the foot of this file.
	REFUND_PRIORITY_FLAGGED: 'Refund Priority Flagged',
	REFUND_PRIORITY_UNFLAGGED: 'Refund Priority Unflagged',
	// Auth funnel: LOGIN_COMPLETED is its terminal, and the one auth-funnel member.
	LOGIN_COMPLETED: 'login_completed',
	// Revenue lifecycle status transitions. OFFER_ is named by QUAL-ACTIVITY-TYPE-RAW-LITERAL-001's fix prose as the
	// adoption target (const/compliance-rules-ssot-literals.ts).
	//
	// DEAL_STATUS_CHANGED is read by QUAL-AUDIT-STATUS-WRITETHROUGH-001's bare-identifier landing test, which a
	// "zero member access" census cannot see (the d1-crud doctrine passes the executor by REFERENCE): without it,
	// flows/property-operations-offers-creation-buy-side-promote-tx.ts (Searching -> Under Contract) and
	// flows/transaction-buying-update.ts (the COALESCE deal_status bind) fire blocking HIGH. There is deliberately NO
	// AUCTION_STATUS_CHANGED: no leaf needs it, because AUCTION_OUTCOME below audits the only auction terminal write in
	// the tree (flows/property-operations-auction-index-tool-cancel.ts).
	OFFER_STATUS_CHANGED: 'offer_status_changed',
	DEAL_STATUS_CHANGED: 'deal_status_changed',
	// Sell-side auction outcome audit row written by flows/auction-outcome.ts. SPELLING IS LOAD-BEARING -- see the Title-Case note at the foot of this file.
	AUCTION_OUTCOME: 'Auction Outcome',
	// Navigator admin listing-review decisions (flows/listing-review-approve.ts, flows/listing-review-decide.ts), audit-pairing the deal_status transition.
	LISTING_PUBLISHED: 'listing_published',
	AUCTION_PUBLISHED: 'auction_published',
	LISTING_REJECTED: 'listing_rejected',
	LISTING_CHANGES_REQUESTED: 'listing_changes_requested',
	// The SELLER-side sibling of that admin DECISION trio: the same deal_status column, one hop earlier, written by
	// flows/navigator-draft-submit-for-review.ts (Draft/Changes Needed -> In Review). `listing_published` is refused for
	// that leaf -- it asserts an event that did not occur.
	LISTING_SUBMITTED_FOR_REVIEW: 'listing_submitted_for_review',
	// Browser-telemetry transport channel (TelemetryProvider track() arg). No PERFORMANCE channel: RUM web-vitals ride
	// browser.web_vital OTLP logRecords.
	CUSTOM: 'custom',
} as const;

/** The Title-Case-with-space members deviate from lowercase snake_case DELIBERATELY: those values are already persisted on historical `activity` rows and dashboard-filtered, so normalising orphans every existing row. */
